/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response model for chunk upload.  Attributes:     success (bool): Indicates if the chunk upload was successful.     chunk_index (int): The index of the chunk that was uploaded.     video_id (str): The ID of the video to which the chunk belongs.
 */
export interface ChunkUploadDTO { 
    success: boolean;
    chunk_index: number;
    video_id: string;
}

